var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"PrivacyPolicy"}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.policy)}})])])])])}
var staticRenderFns = []

export { render, staticRenderFns }